import { useSubscribe } from "./useSubscribe";
import { useStoreReview } from "./useStoreReview";
import { useSoundConfig } from "./useSoundConfig";
import { useParentChatSubscribe } from "./useParentChatSubscribe";

export const useInitialAppConfig = () => {
  useSubscribe();
  useStoreReview();
  useParentChatSubscribe();
  const { bgmSound, audioContext } = useSoundConfig();
  return { bgmSound, audioContext };
};
